import {
   ChronicDiseaseSimple,
   ChronicDiseaseSimpleQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../translations';

type VisitFormLoaderRenderProps = { chronicDiseases: ChronicDiseaseSimple[] };

type VisitFormLoaderProps = {
   readonly patientId: number;
   readonly children: (renderProps: VisitFormLoaderRenderProps) => JSX.Element;
};

export const VisitFormLoader = (props: VisitFormLoaderProps): JSX.Element => {
   const {
      data: chronicDiseases,
      loading: chronicDiseasesLoading,
      error: chronicDiseasesError,
   } = useCqrsSearch<ChronicDiseaseSimple>(() => {
      const query = new ChronicDiseaseSimpleQuery();
      query.patientId = props.patientId;
      query.activeOnly = true;
      return query;
   });

   if (chronicDiseasesLoading) {
      return <LoaderSpinner />;
   }

   if (chronicDiseasesError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={visitDetailsTranslationKeys.diagnoses.errors.fetch}
            displayIndicator
         />
      );
   }

   return props.children({
      chronicDiseases: chronicDiseases,
   });
};
